import { IntegrationsPortErrors } from 'modules/Integrations/domain'
import type { RilletIntegrationConfig } from './rillet.integration.config'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { persistAutoLinkCustomers } from 'Integrations/integrationsConfig/common/AutoLinkCustomers/persistAutoLinkCustomers'

export const rilletConfigurationMutator = async (
  data: RilletIntegrationConfig
): Promise<{
  success: boolean
  error: IntegrationsPortErrors | null
}> => {
  const savePromises = []

  // Save API key if provided and not masked
  const isApiKeyBeingSaved =
    data.apiKey && !/^(sandbox|live)_\*+$/.test(data.apiKey)
  if (isApiKeyBeingSaved && data.apiKey) {
    savePromises.push(
      dashboardv99990101Client.postStoreRilletCredentials({
        apiKey: data.apiKey
      })
    )
  }

  // Save webhook secret only if:
  // 1. It's provided and not empty
  // 2. AND (API key is being saved in this request OR maskedApiKey already exists)
  const hasExistingApiKey = !!data.maskedApiKey

  if (
    data.webhookSecret &&
    data.webhookSecret.trim() !== '' &&
    (isApiKeyBeingSaved || hasExistingApiKey)
  ) {
    savePromises.push(
      dashboardv99990101Client.putStoreRilletWebhookToken({
        webhookSecret: data.webhookSecret.trim()
      })
    )
  }

  const [autoLinkSaved, credentialResults] = await Promise.all([
    persistAutoLinkCustomers('Rillet', data.autoLinkCustomers),
    Promise.all(savePromises)
  ])

  if (!autoLinkSaved || credentialResults.some(result => result.error)) {
    return { success: false, error: IntegrationsPortErrors.Other }
  }

  return { success: true, error: null }
}
